import router from '@/router/index';
import {
  AuthService, UsersService, CompaniesService, StorageService,
} from '@/services';

const INITIAL_STATE = {
  isAuthLoading: false,
};

const store = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations: {
    SET_AUTH_LOADING(state, value) {
      state.isAuthLoading = value;
    },
  },
  actions: {
    async logout({ commit }) {
      await AuthService.signOut();

      commit('global/SET_CURRENT_USER', INITIAL_STATE, { root: true });

      router.push('/login');
    },

    async login({ commit, dispatch }, form) {
      commit('SET_AUTH_LOADING', true);

      try {
        const { user } = await AuthService.signIn(form);

        dispatch('fetchUserProfile', { user });
      } catch (err) {
        console.log(err);

        commit('SET_AUTH_LOADING', false);
      }
    },

    async fetchUserProfile({ dispatch, commit }, { user, app }) {
      const { uid, email } = user;

      try {
        const profile = await UsersService.fetchUserProfile(uid);
        const company = await CompaniesService.fetchCompanyInfo(profile.company_id);
        const logoUrl = await StorageService.getDownloadPathFromURL(company.logo_url);

        if (profile.is_active) {
          commit('global/SET_CURRENT_USER', { uid, email, ...profile }, { root: true });
          commit('global/SET_COMPANY', { ...company, logo_url: logoUrl }, { root: true });

          if (router.currentRoute.path === '/login') {
            router.push('/');
          }

          if (app) {
            dispatch('initApp', app);
          }
        }
      } catch (err) {
        console.log(err);
      }

      commit('SET_AUTH_LOADING', false);
    },

    initApp(methods, app) {
      app.$mount('#app');
    },
  },
};

export default store;
